<template>
  <vue-modal :key="refreshModal" :ref="modalName" :name="modalName" :scrollable="true" :width="875" :height="'auto'" :minHeight="700" :maxHeight="800">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title suggestions-popup-header">{{ title }}</h5>
        <button type="button" class="close" @click="closeModal">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        
        <div class="suggestions-data-container">
          <road-map-initiative-display
            :moat-name="moatName"
            :moat-description="moatDescription"
          />
          <div class="col-12 form-inline pl-0 pb-2" v-if="showCustomInitiative">
            <div class="col-3">
              <div class="d-flex justify-content-left flex-wrap leftLabel">Initiative Summary</div>
            </div>
            <div class="col-9">
              <div class="d-flex justify-content-left flex-wrap labelData"><input v-model="selectedInitiative.initiative" :id="customInitiativeText" :name="customInitiativeText" type="text" class="w-100" /></div>
            </div>
          </div>
          <div class="col-12 form-inline pl-0 pb-2" v-if="showCustomInitiative">
            <div class="col-3">
              <div class="d-flex justify-content-left flex-wrap leftLabel">Initiative Description</div>
            </div>
            <div class="col-9">
               <div id="initiativeDescriptionSection" class="d-flex justify-content-left flex-wrap labelData w-100"><textarea v-model="selectedInitiative.description" id="initiativeDescription" :name="customInitiativeText+'_description'" type="text" class="w-100" rows="4" /></div>
            </div>
          </div>
          <div class="col-12 pt-2">
            <table id="road-map-initiatives-table" :class="table.class" cellspacing="2" width="100%">
              <thead>
                <tr>
                  <th class="suggestions-header radio-button"></th>
                  <th class="suggestions-header">Initiative Ideas to Create Value</th>
                  <th class="suggestions-header text-center" style="padding-right: 0 !important" v-html="successLevelLabel"></th>
                  <th class="suggestions-header text-center" style="padding-right: 0 !important" v-html="salesIncreaseLabel"></th>
                  <th class="suggestions-header text-center" style="padding-right: 0 !important" v-html="costReductionLabel"></th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="artificial-intelligence-tools">
          Artificial-intelligence tools helped create the Initiative Ideas and metric ranges, <br/>based on this customer need and your industry
        </div>
        <div class="suggestions-popup-buttons float-right mr-2">
          <button v-show="displayInitiatives" type="button" class="btn btn-primary mr-4" @click="addInitiative" :disabled="!selectedInitiative.initiative">{{ this.addOrSaveInitiative }}</button>
          <button type="button" class="btn btn-primary ml-2 float-right ml-2 mr-2" @click="closeModal">Close</button>
        </div>
      </div>
    </div>
  </vue-modal>
</template>

<script>
import Vue from "vue";
import $, { type } from "jquery";
import AlertService from "../services/alert.service";
import ContentService from "../services/content.service";
import ValueGroupMap from "../services/chart/value.group.map.service";
import ViewMixins from "../mixins/ViewMixins.vue";
import GlobalMixins from "../mixins/GlobalMixins";
import RoadMapInitiativeDisplay from "../components/RoadMapInitiativeDisplay";

import Swal from 'sweetalert2';
import AdminService from "../services/admin.service";
import "summernote/dist/summernote.css";
import "summernote";

export default {
  name: "RoadMapInitiatives",
  mixins: [ViewMixins, GlobalMixins],
  components: {RoadMapInitiativeDisplay},
  methods: {
    addInitiative() {
      if (this.selectedInitiative) {
          let content = $("#initiativeDescription").summernote("code");
          this.selectedInitiative.description = content;

          if (this.saveEnabled){
            let valueRoadMapInitiatives = [];
            valueRoadMapInitiatives.push({
              initiative: this.selectedInitiative.initiative,
              needNumber: this.needNumber,
              sequenceNumber: this.sequenceNumber,
              needType: this.needType,
              description: this.selectedInitiative.description,
              valueRoadMapId: this.valueRoadMapId
            });

            ValueGroupMap.saveValueRoadMapInitiative(this.surveyCode, valueRoadMapInitiatives, this.valueRoadMapId, (response) => {
                let statusCode = response.data.statusCode;
                if (statusCode == 200) {
                  AdminService.displaySuccessMessage({ text: "Initiative saved successfully." });
                } else {
                  AdminService.displayErrorMessage({ text: response.data.message });
                }
            }, this);
          } else {
            this.$emit('add-initiative', this.selectedInitiative, this.needName);
            this.closeModal();
          }
      } else {
        AlertService.error("Please select an initiative to add.");
      }
    },
    closeModal() {
      if(this.$refs[this.modalName] != null) {
        this.$refs[this.modalName].visible = false;
      }
      this.refreshModal = !this.refreshModal;
      let content = $("#initiativeDescription").summernote("code");
      this.selectedInitiative.description = content;

      this.$emit('refresh-initiative',this.selectedInitiative.initiative, this.selectedInitiative.description);
      this.selectedInitiative = {};
       $("#initiativeDescription").summernote("code", "");
    },
    async loadData() {
      this.selectedInitiativeId = "";
      this.destroyTable();
      this.drawTable();
      let vm = this;
      $(document).ready(function() {
        $("#initiativeDescription").summernote(vm.summernoteConfiguration);
        $("#initiativeDescription").summernote("code", vm.selectedInitiative.description);
      });      
    },
    drawTable() {
      this.table.data = this.moatInitiatives.slice().sort((a, b) => a.initiativeSequenceNumber - b.initiativeSequenceNumber);
      $.extend(this.table.configuration, { columns: this.table.columns });
      $.extend(this.table.configuration, {
        data: $.map(this.table.data, function (d) {
          return [d];
        }),
      });
      setTimeout(() => {
        this.table.dataTable = $("#" + this.table.id).DataTable(this.table.configuration);
        $("#" + this.table.id).show();

        // Re-check previously selected radio button
        if (this.selectedInitiativeId) {
          $(`#${this.table.id} input[type=radio][value="${this.selectedInitiativeId}"]`).prop("checked", true);
        }
        if(this.isInsiderUser) {
          this.$nextTick(() => {
            // Listen to scroll events on the scroll body
            let alertShown = false;
            const scrollContainer = $("#" + this.table.id + "_wrapper .dt-scroll-body");
            scrollContainer.on("scroll", function () {
              $(this).scrollTop(0);
              if (!alertShown) {
                alertShown = true;
                $(this).scrollTop(0);
                Swal.fire({
                  title: '',
                  html: '<h5 class="text-center">You need to activate your full subscription to see all Initiative Ideas.</h5>',
                  showCloseButton: false,
                  showCancelButton: false,
                  showConfirmButton: false,
                  footer: '',
                  allowOutsideClick: true,
                  didOpen: () => {
                    const htmlContainer = document.querySelector('.swal2-html-container');
                    if (htmlContainer) {
                      htmlContainer.classList.remove('swal2-html-container');  // Remove default class
                      htmlContainer.classList.add('no-extra-space');           // Add your custom class
                    }
                  }
                })
                
                // Reset flag after short delay (so it can show again later if needed)
                setTimeout(() => {
                  alertShown = false;
                }, 100); 
              }
            });
          });
        }

        $("#" + this.table.id)
          .off("change", ".select-radio")
          .on("change", ".select-radio", (e) => {
            this.selectedInitiativeId = $(e.target).val();
            const selectedRow = this.table.data.find(row => row.moatInitiativeId == this.selectedInitiativeId);
            //this.selectedInitiative = selectedRow;
            // Work on a deep copy instead
            this.selectedInitiative = JSON.parse(JSON.stringify(selectedRow));
          });
          if (!this.displayInitiatives && !this.showCustomInitiative){
            $("#" + this.table.id + " input.suggestions-popup-radio").hide();
          }
      }, 0);
    },
    destroyTable() {
      $("#" + this.table.id).hide();
      if (typeof this.table.dataTable != "undefined") {
        this.table.dataTable.destroy();
      }
    },
  },
  props: {
    modalName: {
      type: String,
      default: "road-map-initiatives"
    },
    displayInitiatives: {
      type: Boolean,
      default: true
    },
    showCustomInitiative: {
      type: Boolean,
      default: false
    },
    addOrSaveInitiative: {
      type: String,
      default: "Add Initiative"
    },
    saveEnabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      summernoteConfiguration: ContentService.getInitiativeDescriptionConfiguration(),
      refreshModal: true,
      title: "Roadmap Initiatives",
      needName: "",
      needNumber: 0,
      sequenceNumber: 0,
      needType: "",
      valueRoadMapId: 0,
      moatDescription: {
        description: "",
        attributes: "{}"
      },
      moatInitiatives: [],
      moatName: "",
      selectedInitiative: {},
      initiative: "",
      selectedInitiativeId: "",
      initiatives: [],
      features: "",
      element: Object,
      table: {
        id: "road-map-initiatives-table",
        class: "table display wrap row-border table-hover p-0",
        configuration: {
          dom: '<"top"if>rtp<"bottom"><"clear">',
          searching: false,
          scrollY: "200px",
          scrollCollapse: true,
          paging: false,
          //pageLength: 10,
          select: true,
          processing: false,
          responsive: true,
          destroy: true,
          info: false,
          keys: true,
          sort: false,
          bSortable: false,
          bSort: false,
          buttons: [],
          ordering: false, // disable all table sorting
          columnDefs: [
            {
              targets: "_all",
              orderable: false  // Ensures each column is non-sortable
            }
          ],
        },
        columns: ValueGroupMap.getRoadMapInitiativesTableColumnData(),
      },
      successLevelLabel: "Success Opportunity",
      salesIncreaseLabel: "Potential <br/> Sales Lift",
      costReductionLabel: "Potential <br/> Cost Savings",
      customInitiativeText: "",
    };
  },
  computed: {
    moatFeatures() {
      if (typeof this.moatDescription != "undefined" && this.moatDescription != null && this.moatDescription.attributes) {
        let moatAttributes = JSON.parse(this.moatDescription.attributes);
        return moatAttributes?.features || "";
      }
      return "";
    },
    initiativeEmotion() {
      if (typeof this.moatDescription != "undefined" && this.moatDescription != null && this.moatDescription.features) {
        let moatAttributes = JSON.parse(this.moatDescription.features);
        return moatAttributes?.features || "";
      }
      return "";
    }
  },
  mounted() {}
};
</script>
